import React from "react";

import { View, StyleSheet } from "react-native";

import StyledText from "../../components/StyledText";
import { Copy, Layout, Colors } from "../../constants";
import CatalogueResponsiveView from "./CatalogueResponsiveView";

export default function NotFound() {
  return (
    <CatalogueResponsiveView>
      <View style={styles.container}>
        <View style={styles.textContainer}>
          <StyledText style={[styles.text, styles.textTop]}>🤷‍</StyledText>
        </View>
        <View style={styles.textContainer}>
          <StyledText
            style={[styles.text, styles.textHeader, styles.textInfos]}
          >
            {Copy.ns("catalogue.notFound.header")()}
          </StyledText>
        </View>
        <View style={styles.textContainer}>
          <StyledText style={[styles.text, styles.textInfos]}>
            {Copy.ns("catalogue.notFound.body")()}
          </StyledText>
        </View>
        <View style={styles.textContainer}>
          <StyledText style={[styles.text, styles.textInfos]}>
            {Copy.ns("catalogue.notFound.footer")()}
          </StyledText>
        </View>
      </View>
    </CatalogueResponsiveView>
  );
}

const styles = StyleSheet.create({
  container: {
    height: Layout.deviceHeight,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingHorizontal: Layout.mSize(35),
    paddingVertical: Layout.mSize(35),
  },
  textContainer: {},

  text: {
    textAlign: "center",
    color: Colors.font.main,
    fontSize: Layout.mSize(26),
  },

  textInfos: {
    fontFamily: Layout.fontRegular,
    paddingTop: Layout.mSize(36),
  },
  textTop: {
    paddingTop: Layout.mSize(116),
    fontSize: Layout.mSize(60),
  },
  textHeader: {
    fontWeight: "300",
    paddingTop: Layout.mSize(78),
  },
});
